export enum BreadcrumbsBarType {
  NAVIGATION = "navigation",
  INDICATION = "indication"
}
